import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import env from "../../env"
import { getItemDetailPrintUrl } from "../../util/UrlGenerator"
import { IPopupOptions, IPrintOptions, IPrintView } from "./index"

const applicationPath = env.applicationPath

export const showPrintView = (
    itemId: number,
    printOptions: IPrintOptions,
): void => {
    const url = getItemDetailPrintUrl(applicationPath, itemId, printOptions)
    window.open(url)
}

export const printViewSlice = createSlice({
    name: "printView",

    initialState: {
        itemId: 0,
        popupOptions: {},
        printOptions: {},
        isShown: false,
    } as IPrintView,

    reducers: {
        setItemId: (state, action: PayloadAction<number>) => {
            state.itemId = action.payload
        },

        setPrintOptions: (state, action: PayloadAction<IPrintOptions>) => {
            state.printOptions = action.payload
        },

        showDialogue: (state, action: PayloadAction<IPopupOptions>) => {
            const { canShowAttachments, canShowComments, canShowHistory } =
                action.payload
            state.popupOptions = action.payload
            state.isShown =
                canShowAttachments || canShowComments || canShowHistory
        },

        hideDialogue: (state) => {
            state.isShown = false
        },
    },
})

export default printViewSlice.reducer

export const { showDialogue, hideDialogue, setItemId, setPrintOptions } =
    printViewSlice.actions
